import { FC } from "react";

type YoutubeEmbededProps = {
    url?: string;
}

export const YoutubeEmbeded: FC<YoutubeEmbededProps> = ({ url }: YoutubeEmbededProps) => {

    return (
        <div className="flex flex-col w-full h-full ">
            <iframe

                src={`https://www.youtube.com/embed/${url?.split('/').pop()}?modestbranding=1&controls=1&rel=0&showinfo=0`}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="aspect-video w-full h-full"
            ></iframe>
        </div>
    )
}